export default __webpack_public_path__ + "static/media/refresh.e67833fd.svg";